export class UserDashboardSreenSetting {
    handOverSetting: HandOverConfig;
    imageIntervalSetting: IntervalConfig;
    carePlanIntervalSetting: IntervalConfig;
    constructor() {
        this.handOverSetting = new HandOverConfig();
        this.imageIntervalSetting = new IntervalConfig();
        this.carePlanIntervalSetting = new IntervalConfig();
    }
}

export class HandOverConfig {
    handOverTotalDayOptions: number[];
    currentConfigValue: number;
    intervalSetting: IntervalConfig;
    constructor() {
        this.handOverTotalDayOptions = [3, 4, 5, 6, 7];
        this.currentConfigValue = 7;
        this.intervalSetting = new IntervalConfig();
    }
}

export class IntervalConfig {
    currentValue: number;

    constructor() {
        this.currentValue = 30000;
    }
}